/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UpdateCustomerRequest} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'
import {UpdateCustomerResponse} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'


export const updateCustomer = (request: UpdateCustomerRequest, options?: CashRequestOptions) => post<UpdateCustomerRequest, UpdateCustomerResponse>("/2.0/cash/update-customer", request, {...options, rejectOnError: true })